import { observer } from 'mobx-react-lite';

import pig1 from '../../assets/images/game/touch-me/pig-red.png';
import pig2 from '../../assets/images/game/touch-me/pig-yellow.png';
import pig3 from '../../assets/images/game/touch-me/pig-blue.png';
import emptyItem from '../../assets/images/game/result-empty-item.svg';

const pigsImages = [pig1, pig2, pig3];

export const TouchMeResultImageItem = observer(({ item, activeIndex, odd }) => {
  return (
    <div
      className={`c-m-inner-item ${
        (activeIndex || activeIndex === 0) && item?.pigIndex !== activeIndex ? 'disabled' : ''
      }`}
    >
      <div className='c-m-inner-item-frame'>
        {item ? (
          <div className='c-m-inner-item-cloud-wrapper'>
            <div
              className={`${item.bonusMultiplier >= 2 ? 'c-m-multiplier-block' : ''}`}
              data-multiply={`x${item.bonusMultiplier}`}
            />
            <div className='c-m-inner-item-cloud'>
              <svg
                width='96'
                height='57'
                viewBox='0 0 96 57'
                fill='none'
                xmlns='http://www.w3.org/2000/svg'
              >
                <path
                  d='M6 28.3491C6 20.7925 12.8358 14.5595 21.6733 13.6283C23.751 6.8744 30.9608 1.8973 39.5212 1.8973C41.7192 1.88881 43.9058 2.22199 46.0073 2.88558C46.8881 1.82774 48.014 1.01639 49.2806 0.526879C50.5472 0.0373723 51.9133 -0.114409 53.252 0.0856326C54.5908 0.285675 55.8587 0.831054 56.9381 1.67111C58.0176 2.51116 58.8734 3.61865 59.4262 4.8907C61.0399 4.08478 62.81 3.66637 64.6033 3.66693C70.6842 3.66693 75.747 8.405 76.8655 14.6808C77.8717 14.5356 78.8865 14.4629 79.9025 14.4632C89.6334 14.4632 96 20.8852 96 28.8201C96 35.3563 92.1648 39.2215 84.8338 40.9591C84.8338 41.1696 84.8338 41.3765 84.8338 41.587C84.8338 49.5468 78.4897 55.9974 70.6634 55.9974C67.3275 56.0048 64.0951 54.8038 61.5317 52.6044C58.1983 54.9118 54.252 56.0961 50.2374 55.9939C46.2228 55.8916 42.3381 54.5078 39.1195 52.0336C36.6882 53.2112 34.0318 53.8134 31.3452 53.7961C23.0342 53.7961 16.2988 48.3052 16.2988 41.5335C16.2995 41.0726 16.3319 40.6124 16.3957 40.1563C10.2629 37.7944 6 34.3038 6 28.3491Z'
                  fill='#E74C80'
                />
                <path
                  d='M6 27.8432C6 20.4189 12.7769 14.2922 21.5437 13.3849C23.615 6.74861 30.7496 1.8545 39.2473 1.8545C41.4256 1.85132 43.592 2.18275 45.6737 2.83766C46.5473 1.79754 47.6643 0.999718 48.9209 0.518311C50.1774 0.0369041 51.5328 -0.112467 52.861 0.0840745C54.1893 0.280616 55.4473 0.816696 56.5183 1.64251C57.5892 2.46831 58.4384 3.55706 58.9868 4.80759C60.586 4.01619 62.34 3.60469 64.1173 3.60395C70.1365 3.60395 75.1749 8.26311 76.2831 14.4259C77.2805 14.2861 78.286 14.216 79.2928 14.2163C88.9447 14.2163 96 19.707 96 27.4891C96 33.9122 91.4622 38.5064 84.1825 40.2125C84.1825 40.4185 84.2002 40.6246 84.2002 40.8306C84.2002 48.6525 77.9048 54.9924 70.1436 54.9924C66.8332 55.0023 63.6248 53.8239 61.0793 51.6634C57.7732 53.9306 53.8593 55.0944 49.8777 54.994C45.8961 54.8937 42.0432 53.5342 38.8507 51.1032C36.4397 52.2591 33.8062 52.8506 31.1426 52.8345C22.8998 52.8345 16.2185 47.4416 16.2185 40.7836C16.22 40.3313 16.2519 39.8796 16.3141 39.4317C10.2241 37.1112 6 33.7096 6 27.8432Z'
                  fill='white'
                />
                <path
                  d='M10 51C8.34314 51 7 49.6569 7 48C7 46.3431 8.34314 45 10 45C11.6569 45 13 46.3431 13 48C13 49.6569 11.6569 51 10 51Z'
                  fill='white'
                />
                <path
                  d='M2.63497 53.0271C2.36775 51.9553 3.01997 50.8699 4.09172 50.6027C5.16348 50.3354 6.24894 50.9876 6.51616 52.0594C6.78338 53.1312 6.13117 54.2166 5.05941 54.4838C3.98765 54.7511 2.90219 54.0989 2.63497 53.0271Z'
                  fill='white'
                />
                <path
                  d='M2.6226e-06 55.9983C-0.000332594 56.1962 0.0580709 56.3898 0.167823 56.5545C0.277576 56.7192 0.43374 56.8477 0.616535 56.9236C0.799331 56.9995 1.00053 57.0194 1.19467 56.9809C1.38881 56.9423 1.56715 56.8471 1.7071 56.7071C1.84706 56.5672 1.94234 56.3888 1.98087 56.1947C2.0194 56.0005 1.99945 55.7993 1.92355 55.6165C1.84765 55.4337 1.71922 55.2776 1.55451 55.1678C1.3898 55.0581 1.19623 54.9997 0.998305 55C0.733538 55 0.479616 55.1052 0.292397 55.2924C0.105179 55.4796 2.6226e-06 55.7335 2.6226e-06 55.9983Z'
                  fill='white'
                />
                <defs>
                  <filter
                    id='filter0_d_1_2360'
                    x='13.6043'
                    y='21.6842'
                    width='73.897'
                    height='21.6153'
                    filterUnits='userSpaceOnUse'
                    colorInterpolationFilters='sRGB'
                  >
                    <feFlood floodOpacity='0' result='BackgroundImageFix' />
                    <feColorMatrix
                      in='SourceAlpha'
                      type='matrix'
                      values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
                      result='hardAlpha'
                    />
                    <feOffset dy='3.14485' />
                    <feGaussianBlur stdDeviation='3.14485' />
                    <feComposite in2='hardAlpha' operator='out' />
                    <feColorMatrix
                      type='matrix'
                      values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0'
                    />
                    <feBlend
                      mode='normal'
                      in2='BackgroundImageFix'
                      result='effect1_dropShadow_1_2360'
                    />
                    <feBlend
                      mode='normal'
                      in='SourceGraphic'
                      in2='effect1_dropShadow_1_2360'
                      result='shape'
                    />
                  </filter>
                </defs>
              </svg>
            </div>
            <p className='c-m-inner-item-cloud-txt'>x {item.odd}</p>
          </div>
        ) : null}
        <div className='c-m-inner-item-img-block'>
          <img src={item ? pigsImages[item.pigIndex] : emptyItem} alt='' />
        </div>
        <div className='c-m-inner-item-btn-wrapper'>
          {/* For c-m-inner-item-btn add classes // type-1 // type-2 // to change color */}
          {(activeIndex || activeIndex === 0) && item.pigIndex === activeIndex && (
            <span className={`c-m-inner-item-btn ${odd ? 'type-2' : 'type-1'}`}>x{odd}</span>
          )}
        </div>
      </div>
    </div>
  );
});
